// PGCET MCA Mock 5 — Analytical Ability & Logical Reasoning (questions 56–70)
const pgcetmcaAnalyticalReasoning = [
  {
    id: 56,
    question: "Find the next number in the series: 1, 2, 6, 21, 88, ?",
    options: ["A. 440", "B. 450", "C. 445", "D. 352"],
    answer: "C"
  },
  {
    id: 57,
    question: "Find the next letter in the series: B, E, J, Q, ?",
    options: ["A. Z", "B. Y", "C. X", "D. W"],
    answer: "A"
  },
  {
    id: 58,
    question: "In a certain code, ROSE is written as 6821, CHAIR as 73456 and PREACH as 961473. How is SEARCH written in that code?",
    options: ["A. 214763", "B. 241673", "C. 216473", "D. 214673"],
    answer: "D"
  },
  {
    id: 59,
    question: "A is B's sister. C is B's mother. D is C's father. How is A related to D?",
    options: ["A. Daughter", "B. Granddaughter", "C. Grandmother", "D. Niece"],
    answer: "B"
  },
  {
    id: 60,
    question: `Statements: Some apples are mangoes. All mangoes are fruits.
      Conclusions:
      I. Some apples are fruits.
      II. All fruits are mangoes.`,
    options: ["A. Only conclusion I follows", "B. Only conclusion II follows", "C. Both I and II follow", "D. Neither I nor II follows"],
    answer: "A"
  },
  {
    id: 61,
    question: "A, B, C, D and E sit in a row facing north. C sits in the middle. A sits to the immediate left of C. E sits at the extreme right end. B does not sit next to E. Who sits second from the right end?",
    options: ["A. B", "B. A", "C. D", "D. C"],
    answer: "C"
  },
  {
    id: 62,
    question: "A man is facing North. He turns 90° clockwise, then 135° anticlockwise, and then 180° clockwise. Which direction is he facing now?",
    options: ["A. North-West", "B. South-West", "C. North-East", "D. South-East"],
    answer: "D"
  },
  {
    id: 63,
    question: "If 1 March of a non-leap year is a Monday, what day of the week is 1 June of the same year?",
    options: ["A. Monday", "B. Tuesday", "C. Wednesday", "D. Thursday"],
    answer: "B"
  },
  {
    id: 64,
    question: "What is the angle between the hour hand and the minute hand of a clock at 8:20?",
    options: ["A. 120°", "B. 140°", "C. 130°", "D. 150°"],
    answer: "C"
  },
  {
    id: 65,
    question: "Ravi is taller than Sunil but shorter than Tarun. Uday is taller than Tarun. Vikram is shorter than Sunil. Who is the third tallest?",
    options: ["A. Ravi", "B. Tarun", "C. Sunil", "D. Uday"],
    answer: "A"
  },
  {
    id: 66,
    question: `How is M related to N?
      Statement I: M is the son of P.
      Statement II: N is the daughter of P.`,
    options: [
      "A. Statement I alone is sufficient",
      "B. Statement II alone is sufficient",
      "C. Both statements together are needed",
      "D. Both statements together are not sufficient"
    ],
    answer: "C"
  },
  {
    id: 67,
    question: "Find the odd one out: 8, 27, 64, 100, 125",
    options: ["A. 27", "B. 64", "C. 125", "D. 100"],
    answer: "D"
  },
  {
    id: 68,
    question: "Find the missing term: 6 : 222 :: 7 : ?",
    options: ["A. 343", "B. 350", "C. 336", "D. 357"],
    answer: "B"
  },
  {
    id: 69,
    question: "If '×' means '+', '+' means '÷', '−' means '×' and '÷' means '−', then the value of 8 × 12 + 4 − 3 ÷ 5 is",
    options: ["A. 12", "B. 15", "C. 9", "D. 18"],
    answer: "A"
  },
  {
    id: 70,
    question: "A cube of side 5 cm is painted on all its faces and then cut into 1 cm cubes. How many of the small cubes have no face painted?",
    options: ["A. 64", "B. 36", "C. 54", "D. 27"],
    answer: "D"
  }
];

export default pgcetmcaAnalyticalReasoning;
